import { params } from "./wsDataManager";

/**
 * 改造下：保存二进制数据，在需要渲染时，才转换为json数据；
 */

let data_list = []//原始数据保存的list
/**
 * 
 * @param {*} data 
 */
export function saveCacheData(data) {
  data_list.push(data)
};

/**
 * 根据播放时间点、步长获取合适的数据
 * @param {*} time 时间点
 * @param {*} step 步长 毫秒；
 */
export function getCacheData(time, step) {
  let min = time - step / 2;
  let max = time + step / 2;
  let data = data_list.find(item => item.timestamp >= min && item.timestamp < max)
  return data;
}
/**
 * 根据播放时间点、步长获取合适的数据  地图数据
 * @param {*} time 时间点
 * @param {*} step 步长 毫秒；
 */
export function getCacheData_Map(time, step) {
  let min = time - step / 2;
  let max = time + step / 2;
  let data = data_list.find(item => item.timestamp >= min && item.timestamp < max&&item.mapData)
  return data;
}

export function clearCacheData() {
  console.log('clear');
  data_list = [];
};

export function saveChartData(data){
  let chart_list = {
    timestamp:0,
    metricDataFrameList:[]
  };
  if(data?.vehicleData?.metricDataFrameList.length&&data.timestamp){
    chart_list.timestamp = data.timestamp;
    chart_list.metricDataFrameList = data?.vehicleData?.metricDataFrameList;
    return chart_list;
  }
}

